module.exports = __webpack_public_path__ + "static/media/Geo_US_map_regions.0a12a5b1.png";